import { useTranslation } from "react-i18next"
import { PageHeader } from "../../../../Components"
import { frames } from "../../../../Styles"
import { Pages } from "../../../../Navigation/root"

const systemName = "sow unit"

export default function Freeda_esf_settings() {
  const { t } = useTranslation()

  return (
    <frames.Page_inner>
        <PageHeader
          topHeader={systemName}
          subHeader={t(`menuHeaders.${Pages.freeda_esf_settings}`, {defaultValue: "settings"})}
        />
      <frames._page_inner_content>
  
      </frames._page_inner_content>
    </frames.Page_inner>
  )
}